__turbopack_context__.v({
  "accordionContent": "styles-module__4PbuZa__accordionContent",
  "accordionInner": "styles-module__4PbuZa__accordionInner",
  "bar": "styles-module__4PbuZa__bar",
  "chevron": "styles-module__4PbuZa__chevron",
  "chevronExpanded": "styles-module__4PbuZa__chevronExpanded",
  "dropdownItem": "styles-module__4PbuZa__dropdownItem",
  "dropdownItemIn": "styles-module__4PbuZa__dropdownItemIn",
  "dropdownOpen": "styles-module__4PbuZa__dropdownOpen",
  "dropdownPanel": "styles-module__4PbuZa__dropdownPanel",
  "linkIn": "styles-module__4PbuZa__linkIn",
  "logo": "styles-module__4PbuZa__logo",
  "navLink": "styles-module__4PbuZa__navLink",
  "navLinkIn": "styles-module__4PbuZa__navLinkIn",
  "pillBg": "styles-module__4PbuZa__pillBg",
  "shell": "styles-module__4PbuZa__shell",
});
